import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { GameTitle } from "./GameTitle";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";
import { CatContainer } from "./CatContainer";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;
    
    private catContainer: CatContainer;
    private gameTitle: GameTitle;
    private playButton: Button;
    private f: number;
    private audioOnButton: Button;
    private audioOffButton: Button;

    constructor() {

        super("SplashScene");

        SplashScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        this.f = 0;
        
        const background = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "background");
        background.setScale(2);

        const frameUp = this.add.image(GameConstants.GAME_WIDTH / 2, 0, "texture_atlas_7", "frame_up");
        frameUp.scaleY = GameVars.scaleY;
        frameUp.setOrigin(.5, 0);

        const frameMiddle = this.add.image(GameConstants.GAME_WIDTH / 2, frameUp.height * GameVars.scaleY, "texture_atlas_7", "frame_sides");
        frameMiddle.scaleY = GameConstants.GAME_HEIGHT - 2 * frameUp.height * GameVars.scaleY;
        frameMiddle.setOrigin(.5, 0);

        const frameDown = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT, "texture_atlas_7", "frame_up");
        frameDown.scaleY = -GameVars.scaleY;
        frameDown.setOrigin(.5, 0);

        this.catContainer = new CatContainer(this);
        this.add.existing(this.catContainer);

        this.gameTitle = new GameTitle(this);
        this.add.existing(this.gameTitle);

        this.audioOnButton = new Button(this, 70, 70 * GameVars.scaleY, "texture_atlas_4", "btn_sound_on_off", "btn_sound_on_on");
        this.audioOnButton.onDown(this.onClickAudioButton, this);
        this.audioOnButton.setScale(.7, .7 * GameVars.scaleY);
        this.add.existing(this.audioOnButton);

        this.audioOffButton = new Button(this, 70, 70 * GameVars.scaleY, "texture_atlas_3", "btn_sound_off_off", "btn_sound_off_on");
        this.audioOffButton.onDown(this.onClickAudioButton, this);
        this.audioOffButton.setScale(.7, .7 * GameVars.scaleY);
        this.add.existing(this.audioOffButton);

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        this.playButton = new Button(this, GameConstants.GAME_WIDTH - 95, GameConstants.GAME_HEIGHT - 90 * GameVars.scaleY, "texture_atlas_4", "btn_play_off", "btn_play_on");
        this.playButton.onDown(this.onClickPlay, this);
        this.playButton.scaleY = GameVars.scaleY;
        this.add.existing(this.playButton);

        AudioManager.playSound("soundtrack", true, .5);
    }

    public update(): void {

        this.f ++;

        if (this.f === 90) {

            this.tweens.add({
                targets: this.playButton,
                scaleX: .9,
                scaleY: 1.1 * GameVars.scaleY,
                angle: Math.random() > .5 ? -2 : 2,
                y: GameConstants.GAME_HEIGHT - 100 * GameVars.scaleY,
                ease: Phaser.Math.Easing.Cubic.InOut,
                duration: 200,
                yoyo: true
            });

            this.f = 0;
        }

        this.catContainer.update();
    }

    public clickPlayLogic(): void {

    }

    private onClickPlay(): void {

        AudioManager.playSound("btn_click");

        if (!GameVars.addType) {
            let w = <any> window;
            if (typeof w.gdsdk !== 'undefined' && w.gdsdk.showAd !== 'undefined') {
                GameVars.addType = GameConstants.ADD_PLAY;
                w.gdsdk.showAd();
            }
            else {
                GameManager.onClickPlaySplash();
            }
        }
    }

    private onClickAudioButton(): void {

        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        AudioManager.playSound("btn_click");
    }
}
